import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { PowerType } from '@devices/models';

type Size = 'small' | 'medium';

@Component({
  imports: [CommonModule],
  selector: 'avs-energy-icon',
  styleUrl: './energy-icon.component.scss',
  templateUrl: './energy-icon.component.html',
})
export class EnergyIconComponent {
  type = input<PowerType>(PowerType.TOTAL);
  size = input<Size>('small');
  protected readonly ePowerType = PowerType;
}
